import { useState } from "react";
import { Button } from "../../components/ui/button";
import { Receipt, Upload } from "lucide-react";
import { RecordPaymentDialog } from "./RecordPaymentDialog";
import { FlatsBoard } from "./FlatsBoard";
import { inr } from "./mockData";

export function ResidentView({ flats, onSelfReport }) {
  const me = flats.find((f) => f.flat === "A-103");
  const [reportOpen, setReportOpen] = useState(false);
  const owes = me.dueNow + (me.arrears || 0);
  const reported = me.status === "awaiting";

  return (
    <div className="space-y-5">
      <div className="rounded-2xl bg-white border border-stone-200 p-4 text-xs text-stone-500">
        Viewing as <b className="text-stone-800">Suresh Babu · Flat A-103</b> (resident with pending dues)
      </div>

      <div className={`rounded-3xl p-5 text-white ${owes > 0 && !reported ? "bg-[#C05640]" : "bg-stone-900"}`} data-testid="my-dues-card">
        <div className="text-xs uppercase tracking-wider opacity-70">My maintenance · Flat {me.flat}</div>
        {reported ? (
          <>
            <div className="font-serif-display text-2xl mt-1">Payment reported ✓</div>
            <div className="text-sm opacity-80 mt-1">Waiting for treasurer confirmation. Receipt will appear here.</div>
          </>
        ) : owes > 0 ? (
          <>
            <div className="font-serif-display text-3xl mt-1">{inr(owes)} due</div>
            <div className="text-sm opacity-80 mt-1">Apr, May & Jun 2026 (₹2,000/mo) + ₹4,000 old arrears</div>
            <div className="mt-4 flex flex-wrap gap-2">
              <Button onClick={() => setReportOpen(true)} data-testid="i-paid-btn"
                className="bg-white text-[#C05640] hover:bg-stone-100 rounded-full font-semibold">
                <Upload size={15} className="mr-1.5" /> I paid — upload screenshot
              </Button>
            </div>
            <div className="mt-3 text-[11px] opacity-70">Pay via UPI sunrise.assn@upi or bank transfer, then report it here. Not comfortable with apps? Just forward the SMS in WhatsApp — the treasurer can add it for you.</div>
          </>
        ) : (
          <div className="font-serif-display text-2xl mt-1">All paid up 🎉</div>
        )}
      </div>

      <div className="rounded-2xl border border-stone-200 bg-white p-4">
        <div className="text-xs font-semibold text-stone-600 mb-2 flex items-center gap-1"><Receipt size={13} /> My receipts</div>
        {me.receipts.length ? me.receipts.map((r) => (
          <div key={r} className="flex items-center justify-between text-xs text-stone-600 py-2 border-b border-stone-100 last:border-0">
            <span>{r}</span>
            <button className="text-[#25D366] font-semibold" data-testid="resident-receipt-share">Share ↗</button>
          </div>
        )) : <div className="text-xs text-stone-400">No receipts yet</div>}
      </div>

      <div>
        <h2 className="text-base font-semibold mb-2">Community board</h2>
        <p className="text-[11px] text-stone-500 mb-3">Everyone sees the same paid/pending picture — full transparency, no month-end surprises.</p>
        <FlatsBoard flats={flats} readOnly />
      </div>

      <RecordPaymentDialog open={reportOpen} onClose={() => setReportOpen(false)}
        flats={flats} defaultFlatId={me.id} residentMode
        onRecorded={() => onSelfReport(me.id)} />
    </div>
  );
}
